import { ChangeDetectionStrategy, Component, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { ObjectTypes } from '@fi-shared/types';
import { FiNewsFeedPinService } from '@fi-shared/fi-news-feed-shared/fi-news-feed-pin.service';

@Component({
    selector: 'fi-news-feed-pin',
    template: `
        @if (isPinned) {
          <button
            mat-button
            class="pin-actions hide-mobile"
            [matMenuTriggerFor]="newsFeedPinMenu"
            [disabled]="!showPinActions()"
            >
            <span class="fas fa-thumbtack pin-actions-icon"></span>
            {{ 'post.pinned' | fiAppText }}
          </button>
          <button
            mat-icon-button
            class="pin-actions show-mobile"
            [matMenuTriggerFor]="newsFeedPinMenu"
            [disabled]="!showPinActions()"
            >
            <mat-icon class="fas fa-thumbtack pin-actions-icon"></mat-icon>
          </button>
        }
        
        <mat-menu #newsFeedPinMenu [class]="'fi-news-feed-pin-menu'">
          <button mat-menu-item (click)="onOpenSettingsClick()">
            <span class="fa fa-cog menu-item-icon"></span>
            {{ 'post.pin_settings' | fiAppText }}
          </button>
          <button mat-menu-item (click)="onRemoveClick()">
            <span class="fas fa-thumbtack menu-item-icon remove-pin"></span>
            {{ 'post.remove_pin' | fiAppText }}
          </button>
        </mat-menu>
        `,
    styleUrls: ['./fi-news-feed-pin.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-news-feed-pin' },
    standalone: false,
})
export class FiNewsFeedPinComponent {
    @Input() objectId: number;
    @Input() objectType: ObjectTypes;
    @Input() isPinned: boolean;

    @Output() openSettingsClick = new EventEmitter<void>();
    @Output() removeClick = new EventEmitter<void>();

    constructor(private newsFeedPinService: FiNewsFeedPinService) {}

    showPinActions() {
        return this.newsFeedPinService.canChangePin(this.objectType);
    }

    onOpenSettingsClick() {
        this.openSettingsClick.emit();
    }

    onRemoveClick() {
        this.removeClick.emit();
    }
}
